import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';

export async function acceptAgreement(
    consentType:
        | 'Marketing offers'
        | 'Migration'
        | 'Personalization'
        | 'Customer Agreement and Privacy policy'
        | 'Offer and Renewal terms'
        | '(Updated) Customer Agreement and Privacy Policy'
        | 'Quebec Customer Agreement and Privacy policy'
        | 'Save offers',
    {
        request,
    }: {
        request: {
            version: string;
            language: string;
            countryCode: string;
        };
    },
    { clientSdk }: DependenciesPayload,
) {
    return clientSdk.user.updateAccount({
        privacyAgreements: [
            {
                ...request,
                consentType,
                countryCode: request.countryCode?.toUpperCase(),
                platform: 'Web',
                appVersion: '1.0',
            },
        ],
    });
}
